import React from "react";
import { RouterProvider } from "react-router";
import router from "./routes";
import { authStore, wishlistStore, cartStore, geoBlockStore } from "./stores/main";
import { observer } from "mobx-react";
import GlobalPopup from "@components/GlobalPopup/GlobalPopup";
import ProductPopup from "@components/ProductPopup/ProductPopup";
import { HeroBannerProvider } from './contexts/HeroBannerContext';
import { HelmetProvider } from 'react-helmet-async';
import './styles/toast.scss';
import './styles/common.scss';
import './services/analytics';
import { gtagService } from './services/gtag';
import Favicon from './components/Favicon/Favicon';
import GeoBlockScreen from './components/GeoBlockScreen/GeoBlockScreen';

const InitApp = observer(() => {

  React.useEffect(() => {
    // Only fetch user data if authenticated
    if (authStore.isAuthenticated) {
      authStore.fetchUser();
      wishlistStore.fetchWishlist();
      cartStore.fetchCart();
    }
  }, []);

  return <></>;
});

// OpenPanel analytics (WEB-4044) initializes on import of ./services/analytics.

// Initialize Gtag
gtagService.init();

geoBlockStore.checkLocation();

const App = observer(() => {
  if (geoBlockStore.isChecking) return null;
  if (geoBlockStore.isBlocked) return <GeoBlockScreen />;

  return (
    <HelmetProvider>
      <Favicon />
      <HeroBannerProvider>
        <InitApp />
        <RouterProvider router={router} />
        <GlobalPopup />
        <ProductPopup />
      </HeroBannerProvider>
    </HelmetProvider>
  );
});

export default App;
